module.exports = __webpack_public_path__ + "img/sitting.729389d5.png";